export function normalizeValue(text) {
  if (text === null || text === undefined) return '';

  if (text === true || (typeof text === 'string' && text.trim().toLowerCase() === 'true')) return 'Sí';
  if (text === false || (typeof text === 'string' && text.trim().toLowerCase() === 'false')) return 'No';

  if (isDateLike(text)) {
    const onlyDate = extractYMD(text);
    if (onlyDate) {
      const { y, m, d } = onlyDate;
      return `${pad2(d)}/${pad2(m)}/${y}`;
    }
  }

  return String(text).trim() ? String(text).trim() : "Empty";
}

function isDateLike(v) {
  if (v instanceof Date) return true;
  if (typeof v !== 'string' && typeof v !== 'number') return false;
  const s = String(v).trim();
  return /^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/.test(s);
}

function extractYMD(v) {
  const s = String(v).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (!y || !mo || !d) return null;
  return { y, m: mo, d };
}

function pad2(n) {
  return String(n).padStart(2, '0');
}

/**
 * Formatea una fecha para inputs de tipo date (YYYY-MM-DD)
 * Acepta fechas ISO, Date objects, o strings con formato de fecha
 */
export function formatDateForInput(value) {
  if (!value) return '';

  // Si es un string ISO o similar, extraer solo YYYY-MM-DD
  if (typeof value === 'string') {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
  }

  // Si es un Date object
  if (value instanceof Date) {
    const y = value.getFullYear();
    const m = pad2(value.getMonth() + 1);
    const d = pad2(value.getDate());
    return `${y}-${m}-${d}`;
  }

  return '';
}